import React, {useCallback, useReducer, useRef, useState} from 'react'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import WizImage from '../../../../components/image/WizImage'

import TextArea from '../../../../components/input/TextArea'
import ic_plus from '../../../../assets/images/ic_plus.png'
import ic_trash from '../../../../assets/images/icon_trash.png'
import {postUploadImage} from '../../../../apis/image/postUploadImage'
import WizButton from '../../../../components/button/WizButton'
import {createPostApi} from '../../../../apis/post/createPostApi'
import useNavigation from '../../../../hooks/useNavigation'
import WizSelect from '../../../../components/select/WizSelect'
import Text from '../../../../components/text/Text'
import useQueryUserDetail from '../../../../hooks/api/user/useQueryUserDetail'

interface IProps {
    className?: string
    postId?: string
}

const initState = {
    title: '',
    content: '',
    channel: 'ko',
    visibility: 0,
}

const PostCreateContainer: React.FC<IProps> = ({className}) => {
    const {goPostList} = useNavigation()
    const [imageList, setImageList] = useState([])
    const [state, dispatch] = useReducer(reducer, initState)
    const {title, content, channel, visibility} = state

    const {data, refetch} = useQueryUserDetail(localStorage?.getItem('wiz-admin-userId'))

    function reducer(state, action) {
        switch (action.type) {
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    const imageRef = useRef<any>()

    const onChangeImage = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            setImageList([...imageList, result?.image_url])
        }
    }

    const onClickRemoveImage = image => {
        setImageList(imageList.filter(item => item !== image))
    }

    const onClickCreatePost = async () => {
        const postType = 'post'

        await createPostApi({
            type: postType,
            title: title,
            content: content,
            channel: channel,
            visibility: visibility,
            images: imageList,
        }).then(() => {
            alert('Create Post Complete')
            goPostList()
        })
    }

    const onChannelChange = useCallback(e => {
        dispatch({
            type: 'field_update',
            field: 'channel',
            value: e,
        })
    }, [])

    return (
        <>
            <div className={'my-[30px]'}>
                <Text className={'text-ti3'}>Now Login Account</Text>
                <div
                    className={
                        'flex items-center gap-x-[5px] bg-white mt-[7px] px-[30px] py-[10px] border border-line02 rounded-[5px] text-center w-fit'
                    }>
                    <WizImage
                        src={`${data?.thumbnail}?type=webp&width=1000&quality=100`}
                        className={'w-[36px] h-[36px] rounded-full'}
                    />
                    <Text className={'text-ti2'}>{data?.name}</Text>
                </div>
            </div>
            <div className={'flex space-x-[10px]'}>
                <WizSelect
                    optionKey="channel"
                    value={channel}
                    onChange={onChannelChange}
                    className={'sm:w-full'}
                    buttonClassName={'sm:w-full sm:min-w-full'}
                />
                <WizSelect
                    optionKey="visibility"
                    value={visibility}
                    onChange={e => {
                        dispatch({
                            type: 'field_update',
                            field: 'visibility',
                            value: e,
                        })
                    }}
                    className={'sm:w-full'}
                    buttonClassName={'sm:w-full sm:min-w-full'}
                />
            </div>
            <div className={'mt-[30px] space-y-[60px] p-[40px] bg-white rounded-[10px] shadow-normal sm:p-[20px]'}>
                <div>
                    <UnderLineInput
                        value={title}
                        onChanged={text => dispatch({type: 'field_update', field: 'title', value: text})}
                    />
                </div>
                <div>
                    <TextArea
                        value={content}
                        onChanged={text => dispatch({type: 'field_update', field: 'content', value: text})}
                        textAreaClassName={'h-[600px]'}
                    />
                </div>
            </div>
            <div className={'mt-[30px] p-[40px] bg-white rounded-[10px] shadow-normal sm:p-[20px]'}>
                <div className={'flex space-x-[20px] items-center min-h-[200px]'}>
                    {imageList?.map(item => (
                        <div className={'relative'}>
                            <WizImage
                                src={`${item}?type=webp&width=1000&quality=100`}
                                className={'w-[200px] rounded-[10px]'}
                            />
                            <div className={'absolute top-[-15px] right-[-15px]'}>
                                <WizImage
                                    onClick={() => onClickRemoveImage(item)}
                                    src={ic_trash}
                                    className={
                                        'bg-white w-[30px] p-[3px] rounded-full border border-line02 cursor-pointer'
                                    }
                                />
                            </div>
                        </div>
                    ))}
                    <div>
                        <WizImage
                            src={ic_plus}
                            className={'w-[60px] cursor-pointer'}
                            onClick={() => imageRef?.current.click()}
                        />
                        <input type={'file'} onChange={e => onChangeImage(e)} ref={imageRef} className={'hidden'} />
                    </div>
                </div>
            </div>

            <div className={'text-center mt-[30px]'}>
                <WizButton text={'Create Post'} size={'medium'} onClick={() => onClickCreatePost()} />
            </div>
        </>
    )
}

export default PostCreateContainer
